import { DesignIssuesComponent } from '../design-issues/design-issues.component';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { HlmBadgeImports } from '@spartan-ng/helm/badge';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTypographyImports } from '@spartan-ng/helm/typography';
import {
  canActivateDesign,
  ptToMm,
  VoucherDesign,
  VoucherType,
  voucherTypeLabel,
} from '../../../../../services/voucher-design.service';
import { DesignThumbnailComponent } from '../design-thumbnail/design-thumbnail.component';

/** Pick the design a voucher type prints on, from the designs of that type. */
@Component({
  selector: 'app-switch-design-dialog',
  standalone: true,
  imports: [
    DesignIssuesComponent,
    HlmBadgeImports,
    HlmButtonImports,
    HlmDialogImports,
    HlmSpinnerImports,
    HlmTypographyImports,
    DesignThumbnailComponent,
  ],
  templateUrl: './switch-design-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchDesignDialogComponent {
  readonly activatable = canActivateDesign;
  /** The slot being switched; null closes the dialog. */
  readonly voucherType = input<VoucherType | null>(null);
  readonly designs = input<VoucherDesign[]>([]);
  readonly activeId = input<string | null>(null);
  readonly busyId = input<string | null>(null);

  readonly choose = output<VoucherDesign>();
  readonly close = output<void>();

  readonly title = computed(() => {
    const type = this.voucherType();
    return type ? `Design für ${voucherTypeLabel(type)}e wählen` : '';
  });
  readonly candidates = computed(() => {
    const type = this.voucherType();
    return this.designs().filter((d) => d.voucher_type === type);
  });

  sizeLabel(design: VoucherDesign): string {
    return `${ptToMm(design.page_width_pt)} × ${ptToMm(design.page_height_pt)} mm`;
  }

  onDialogState(state: 'open' | 'closed') {
    if (state === 'closed' && this.voucherType()) this.close.emit();
  }
}
